"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearnosityService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var Constants_1 = require("../../modules/Constants");
var LearnosityService = /** @class */ (function (_super) {
    __extends(LearnosityService, _super);
    function LearnosityService(options, engineSignatureClient, authoringSignatureClient) {
        var _this = _super.call(this, options) || this;
        _this.engineSignatureClient = engineSignatureClient;
        _this.authoringSignatureClient = authoringSignatureClient;
        return _this;
    }
    LearnosityService.newInstance = function (options) {
        return new LearnosityService(options, insync_assess_sdk_1.SignatureClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), insync_assess_sdk_1.AuthoringSignatureClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized));
    };
    LearnosityService.prototype.signPreviewAssessmentRequest = function (assessmentId_1) {
        return __awaiter(this, arguments, void 0, function (assessmentId, config) {
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signPreviewAssessmentRequest(assessmentId, config, this.getDefaultHeaders())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signReviewAttemptRequest = function (attemptId_1, items_1) {
        return __awaiter(this, arguments, void 0, function (attemptId, items, renderingType, config, assigneeId, curriculumId) {
            if (renderingType === void 0) { renderingType = 'inline'; }
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signReviewAttemptRequest(attemptId, items, renderingType, config, assigneeId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signPreviewRubricRequest = function (attemptId, externalItemId, responses, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signPreviewRubricRequest(attemptId, externalItemId, responses, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signPreviewItemsRequest = function (externalItemId, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authoringSignatureClient.signPreviewItemsRequest(externalItemId, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signEditAssessmentTemplateRequest = function (assessmentTemplateId_1) {
        return __awaiter(this, arguments, void 0, function (assessmentTemplateId, config, curriculumId) {
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authoringSignatureClient.signEditAssessmentTemplateRequest(assessmentTemplateId, config, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signViewAssessmentTemplateRequest = function (assessmentTemplateId_1) {
        return __awaiter(this, arguments, void 0, function (assessmentTemplateId, config, inline, items, curriculumId) {
            if (config === void 0) { config = {}; }
            if (inline === void 0) { inline = false; }
            if (items === void 0) { items = []; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authoringSignatureClient.signViewAssessmentTemplateRequest(assessmentTemplateId, inline, items, config, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signPlayAttemptRequest = function (attemptId_1) {
        return __awaiter(this, arguments, void 0, function (attemptId, config, curriculumId) {
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signPlayAttemptRequest(attemptId, config, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signMonitorAssessmentRequest = function (assessmentId_1) {
        return __awaiter(this, arguments, void 0, function (assessmentId, report) {
            if (report === void 0) { report = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signMonitorAssessmentRequest(assessmentId, report, this.getDefaultHeaders())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.signStudentDetailReportRequest = function (attemptId_1, items_1) {
        return __awaiter(this, arguments, void 0, function (attemptId, items, config, curriculumId) {
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.engineSignatureClient.signStudentDetailReportRequest(attemptId, items, config, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LearnosityService.prototype.initLernosityItemApi = function (signedRequest, config, successCallback, sampleAnswersCallback) {
        if (config === void 0) { config = {}; }
        var learnosityApi = window[Constants_1.LEARNOSITY_ITEMS_API];
        if (typeof learnosityApi.reset !== 'undefined') {
            learnosityApi.reset();
        }
        var items = signedRequest.request.items;
        var existAllItems = items.every(function (item) { return !!document.querySelector("[data-reference=\"".concat(item.id, "\"]")); });
        if (!existAllItems)
            return;
        var api = learnosityApi.init(signedRequest, __assign({ errorListener: function (e) {
                console.log('LearnosityService::errorListener', e);
            }, readyListener: function (e) {
                if (successCallback)
                    successCallback();
                if (sampleAnswersCallback) {
                    var questions = api.getQuestions();
                    var sampleAnswersLoaded_1 = {};
                    Object.values(questions).forEach(function (question) {
                        var _a;
                        if ((_a = question === null || question === void 0 ? void 0 : question.metadata) === null || _a === void 0 ? void 0 : _a.sample_answer) {
                            sampleAnswersLoaded_1[question.metadata.widget_reference] =
                                question.metadata.sample_answer;
                        }
                    });
                    sampleAnswersCallback(sampleAnswersLoaded_1);
                }
            } }, config));
    };
    LearnosityService.prototype.mapItemsToSigned = function (items) {
        return items.map(function (item) { return ({
            id: item.externalBankItemId,
            reference: item.externalId,
        }); });
    };
    return LearnosityService;
}(base_service_1.BaseService));
exports.LearnosityService = LearnosityService;
